import { Component, forwardRef, Host, Input, OnDestroy, OnInit, Optional, SkipSelf } from '@angular/core';
import { ControlContainer, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subscription } from 'rxjs';
import { MasterService } from 'src/app/services/master.service';
import { FormControlBase } from 'src/app/shared/inputs/form-control-base';

@Component({
  selector: 'app-input-radio-marital-status',
  templateUrl: './input-radio-marital-status.component.html',
  styleUrls: ['./input-radio-marital-status.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputRadioMaritalStatusComponent),
      multi: true
    }
  ]
})
export class InputRadioMaritalStatusComponent extends FormControlBase<any> implements OnInit, OnDestroy {

  @Input() groupClass;
  @Input() id;
  @Input() labelClass;
  @Input() label;
  @Input() name;

  items: Array<any>;
  subscription$: Subscription;

  constructor(
    @Optional() @Host() @SkipSelf()
    private cc: ControlContainer,
    private masterService: MasterService
  ) { super(cc); }

  ngOnInit() {
    this.checkInitialControl();
    this.createRelationshipList();
  }

  ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }

  private createRelationshipList() {
    this.subscription$ = this.masterService.getMaritalStatus().subscribe(data => {
      this.items = data.map(item => {
        return { id: item.code, value: item.id, label: item.name };
      });
    });
    // this.items = [
    //   { id: 'single', value: 1, label: 'โสด' },
    //   { id: 'married', value: 2, label: 'สมรส' },
    //   { id: 'divorce', value: 3, label: 'หย่าร้าง' },
    // ];
  }
}
